import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";

/**
 * Plant explorer routes are mobile-only; desktop users are sent to the plants catalog.
 */
export function usePlantExplorerMobileGate(): boolean {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();

  useEffect(() => {
    if (!isMobile) {
      navigate("/products-plants", { replace: true });
    }
  }, [isMobile, navigate]);

  return isMobile;
}
